import { OurClients } from "./ourClients";

export function UseCases() {
  return (
    <section className="bg-[#EDF1FF] py-[48px] z-50">
      <OurClients />
    </section>
  );
}
